import React from "react";
import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import { Tooltip } from "antd";
import CustomLink from "components/Common/buttons/CustomLink";
import { segmentWithColor } from "pages/price-management/PriceManagement/utils";
import { daysToToday, userHasOneOfRoles } from "utils/helpers/functions";
import { USER_ROLES } from "utils/constants";

const color = "#444444";

const hideRoles = [USER_ROLES.TSS];
export const repossessedListColumns = () => [
  {
    title: "Customer ID",
    dataIndex: "id",
    render: textFormatter,
  },
  {
    title: "Full Name",
    dataIndex: "",
    render: row => {
      const fullName = `${row.firstName} ${row.lastName}`;
      return userHasOneOfRoles(hideRoles) ? (
        textFormatter(fullName)
      ) : (
        <Tooltip placement="bottom" title={`${row.firstName} ${row.lastName} details`} color={color}>
          <div>
            <CustomLink to={`/customers/customer/${row.id}?backUrl=/customers/customers/repossessed`}>
              {textFormatter(fullName)}
            </CustomLink>
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "Customer Segment",
    dataIndex: "priceSegment",
    render: segmentWithColor,
  },
  {
    title: "Document ID",
    dataIndex: "document",
    render: cellContent => textFormatter(cellContent?.number),
  },
  {
    title: "TSR",
    dataIndex: "technician",
    render: (cellContent, row) => {
      const { installationDate, growthTechnician, technician, type } = row;

      const ageAsCustomer = daysToToday(installationDate);
      const technicianEmail =
        type === "Commercial" ? technician ?? growthTechnician : ageAsCustomer > 30 ? technician : growthTechnician;

      return technicianEmail ? (
        <CustomLink underlined target="_blank" to={`/user/${technicianEmail}`}>
          {technicianEmail}
        </CustomLink>
      ) : (
        textFormatter(technicianEmail)
      );
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    render: textFormatter,
  },
  {
    title: "Category",
    dataIndex: "type",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: cellContent => (
      <CustomLink underlined to={`/depots/depot?name=${cellContent}`} target={"_blank"}>
        {cellContent}
      </CustomLink>
    ),
  },
  {
    title: "Installation Date",
    dataIndex: "installationDate",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
  {
    title: "Repossession Date",
    dataIndex: "updatedAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
];
